import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "center-wrapper" }
const _hoisted_2 = { class: "input-block" }
const _hoisted_3 = {
  class: "inline-or-block",
  style: {"padding-left":"4px"}
}
const _hoisted_4 = {
  key: 0,
  class: "invalid-text",
  style: {"text-align":"center","padding":"2px"}
}
const _hoisted_5 = { class: "input-block" }
const _hoisted_6 = { class: "input-block" }
const _hoisted_7 = { class: "input-block" }
const _hoisted_8 = { class: "input-block" }
const _hoisted_9 = { class: "input-block" }
const _hoisted_10 = {
  key: 0,
  class: "invalid-text",
  style: {"text-align":"center","padding":"2px"}
}
const _hoisted_11 = { style: {"text-align":"center","padding-top":"20px"} }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!
  const _component_select_action = _resolveComponent("select-action")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block-label" }, "顧客コード", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control no-ime",
          type: "tel",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newHistory.customerId) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchCustomer && _ctx.searchCustomer(...args)))
        }, null, 544), [
          [_vModelText, _ctx.newHistory.customerId]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args)))
          }, "検索")
        ])
      ]),
      (_ctx.customerNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "対応する顧客が見つかりませんでした"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block-label" }, "顧客名", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.newHistory.customerName,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newHistory.customerName) = $event)),
          tabindex: "-1",
          readonly: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block-label" }, "顧客名カナ", -1)),
        _createVNode(_component_JapaneseInput, {
          modelValue: _ctx.newHistory.customerKana,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newHistory.customerKana) = $event)),
          tabindex: "-1",
          readonly: ""
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block-label" }, "対応種類", -1)),
        _createVNode(_component_select_action, {
          action: _ctx.newHistory.actionId,
          "onUpdate:action": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newHistory.actionId) = $event))
        }, null, 8, ["action"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          class: "block-label",
          style: {"vertical-align":"top"}
        }, "対応内容", -1)),
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newHistory.detail) = $event)),
          rows: "5"
        }, null, 512), [
          [_vModelText, _ctx.newHistory.detail]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block-label" }, "対応日時", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "datetime-local",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newHistory.date) = $event))
        }, null, 512), [
          [_vModelText, _ctx.newHistory.date]
        ]),
        (!_ctx.$root.util.isValidDate(_ctx.newHistory.date))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "有効な日付ではありません"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn-primary",
        disabled: _ctx.customerNotFound,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, "保存", 8, _hoisted_12)
    ])
  ], 64))
}